import LogisticalConcept from '../../../../../models/LogisticalConcept'
import {
    GroupLogisticalConcept,
    LogisticalDeclarationExcelData
} from '../../../types'
import { getRowCost } from './getRowCost'
import { Row } from './types'
import { addRowStyles, borderThin, COLOR, textBold } from './utils'

export function getRowsDestinationCosts(
    data: LogisticalDeclarationExcelData[],
    groupConcepts: GroupLogisticalConcept[]
) {
    const rows: Row[][] = []
    getDestionationConcepts(groupConcepts).forEach(concept => {
        rows.push(getRowCost(concept, data, ['extra_national_costs']))
    })
    const rowSummary: Row[] = [
        {
            value: 'Costos en destino',
            backgroundColor: COLOR.yellow
        }
    ]
    data.forEach(d => {
        rowSummary.push({
            value: d.data_summary.extra_national_original_cost,
            format: '0.00',
            backgroundColor: COLOR.yellow
        })
        rowSummary.push({
            value: '',
            backgroundColor: COLOR.yellow
        })
        rowSummary.push({
            value: '',
            backgroundColor: COLOR.yellow
        })
        rowSummary.push({
            value: d.data_summary.extra_national_local_cost,
            format: '0.00',
            backgroundColor: COLOR.yellow
        })
        rowSummary.push({
            value: '',
            backgroundColor: COLOR.gray
        })
    })
    rows.push(addRowStyles(rowSummary, [borderThin, textBold]))
    return rows
}

function getDestionationConcepts(groupConcepts: GroupLogisticalConcept[]) {
    const destinationConcepts: LogisticalConcept[] = []
    groupConcepts
        .filter(groupConcept => groupConcept.id === 4)
        .forEach(groupConcept => {
            groupConcept.logistical_concepts.forEach(concept => {
                destinationConcepts.push(concept)
            })
        })
    return destinationConcepts
}
